'use client';

import { Stack } from '@mui/material';
import { usePathname } from 'next/navigation';
import ProfileMobileNavigator from '@/containers/profile/components/ProfileMobileNavigator';
import { ROUTES } from '@/utils/constants';
import Navbar from '@/components/layout/Navbar';
type NavbarProps = {
  isLoggedIn: boolean;
};
const ResponsiveNavbar = ({
  isLoggedIn
}: NavbarProps) => {
  const pathname = usePathname();
  return pathname?.includes(ROUTES.dashboard.root.href) ? <>
      <Stack sx={{
      display: {
        md: 'none'
      }
    }}>
        <ProfileMobileNavigator />
      </Stack>
      <Stack sx={{
      display: {
        xs: 'none',
        md: 'flex'
      }
    }}>
        <Navbar isLoggedIn={isLoggedIn} />
      </Stack>
    </> : <Navbar isLoggedIn={isLoggedIn} />;
};
export default ResponsiveNavbar;